<template>
  <div>
    <!-- dialog -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="importDialog"
      :title="dialogTitle"
      width="75%"
      @close="clearImportData"
    >
      <el-row class="import-table">
        <ImportData
          ref="import"
          :showBtn="false"
          importName="file"
          :excelName="excelName"
          :tableData="importTable"
          :uploadUrl="uploadUrl"
          @beginUpload="beginUpload"
          @returnData="returnData"
        >
          <el-popover
            v-if="permissionData.length > 1"
            placement="bottom"
            trigger="click"
          >
            <span v-for="(item, index) in permissionOriginData" :key="index">
              <el-link
                type="primary"
                v-if="permissionData.includes(item.href)"
                >{{ item.name }}</el-link
              >
            </span>
            <el-button slot="reference">下载模板</el-button>
          </el-popover>
          <el-button v-else size="mini" @click="downloadFile"
            >下载模板</el-button
          >
        </ImportData>
      </el-row>
      <wxe-table
        ref="wxeTable"
        :title="title"
        :importRowErrMsg="'errorMsg'"
        :tableData="importTable"
        :tableHead="tableColumns"
        :loading="loading"
        @wxe-table-select="importTableChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="sumbitTableData"
          :loading="submitLoading"
          :disabled="importSelection.length === 0"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ImportData from '@/components/ImportData';
import WxeTable from '@/components/ImportData/WxeTable';
import { pageNameArr } from '@/utils/pageInfo';
import download from '@/utils/download';
import { groupBy, toPairs } from 'lodash';

export default {
  components: { ImportData, WxeTable },
  data() {
    return {
      msg: '',
      showTable: false,
      loading: false,
      importDialog: false,
      uploadUrl:
        process.env.VUE_APP_CML_BASE_URL +
        'packingMaterialSample/batchImportPreview',
      importTable: [],
      tableColumns: [
        { prop: 'errorMsg', label: '提示' },
        { prop: 'supplierName', label: '供应商' },
        { prop: 'productName', label: '产品名称' },
        { prop: 'accessoryName', label: '配件名称' },
        { prop: 'useClassificationName', label: '用途分类' },
        { prop: 'formName', label: '包材形式' },
        { prop: 'capacityUnitName', label: '包材容量单位' },
        { prop: 'capacity', label: '包材容量' },
        { prop: 'price', label: '预估含税价' },
        { prop: 'material', label: '材质' },
        { prop: 'havePatentName', label: '是否有专利' },
        { prop: 'productionCycle', label: '生产周期(天)' },
        { prop: 'minNum', label: '正式订单的最低起订量(个)' },
        { prop: 'haveMassProductionName', label: '是否做过大货生产' },
        { prop: 'developmentProgress', label: '开发进度' },
        { prop: 'brandsUsed', label: '已使用品牌' },
        { prop: 'deliveryTime', label: '样品的发货时间' },
        { prop: 'shuiyangEnableName', label: '是否被水羊启用过' },
      ],
      excelName: '包材样品导入模板.xlsx',
      title: 'daoru',
      dialogTitle: '批量导入文件上传',
      importSelection: [],
      permissionOriginData: [],
      permissionData: [],
      hasMorePermission: false,
      submitLoading: false,
    };
  },
  props: {
    importParams: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    importTable(val) {
      if (val.length === 0) this.$refs.import.fileList = [];
    },
  },
  mounted() {
    const { category } = this.$store.getters.userSupplier;
    this.category = category;
    // 判断是否具有多个权限, 目前外部供应商只有一种权限
    this.permissionOriginData = pageNameArr;
    this.permissionData = this.category.reduce((prev, cur) => {
      if (this.permissionOriginData.findIndex(item => item.type === cur) > -1) {
        prev.push(cur);
      }
      return prev;
    }, []);
  },
  methods: {
    beginUpload() {
      this.loading = true;
    },
    // 返回预览导入数据
    returnData(val) {
      this.loading = true;
      this.importTable = val;
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    // 添加导入明细
    sumbitTableData() {
      // 判断是否有不符合导入要求的数据
      if (this.importTable.length === 0) {
        this.$message.error('导入数据为空，请重新选择文件');
        this.$refs.import.loading = false;
        return;
      }
      if (this.importSelection.some(item => item.errorMsg)) {
        this.$message.error('所选数据包含错误数据，请重新选择');
        this.$refs.import.loading = false;
        return;
      }
      const parmas = this.combinationData();
      this.$http.sampleManage
        .batchImportPackingMaterialSample(parmas)
        .then(() => {
          this.$message.success('导入成功！');
          this.importDialog = false;
          this.importSelection = [];
          this.$emit('refresh');
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.submitLoading = false;
          this.$refs.import.loading = false;
        });
    },
    // 删除导入列表所选数据
    deleteImportData() {
      this.$confirm('确定删除选中数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.importTable = this.importTable.filter(
          item => !this.importSelection.includes(item),
        );
        this.importSelection = [];
        this.$refs.wxeTable.removeSelecteds();
      });
    },
    clearImportData() {
      this.importTable = [];
      this.importSelection = [];
      this.$refs.import.remove();
    },
    importTableChange(val) {
      this.importSelection = val;
    },
    // 下载模板文件
    downloadFile() {
      download(
        process.env.VUE_APP_CML_BASE_URL + 'packingMaterialSample/downloadFile',
        this.excelName,
      );
    },
    combinationData() {
      this.submitLoading = true;
      // 供应商商品分组
      const allGroupedItems = toPairs(
        groupBy(this.importSelection, 'supplierCode'),
      ).map(item => {
        return {
          supplierCode: item[0],
          arr: toPairs(groupBy(item[1], 'productName')),
        };
      });
      // 获取第一个供应商商品分类
      const groupedItems = allGroupedItems[0].arr.map(o => o[1]);
      // 组合商品数据（accessoryCmds/capacityUnitPriceCmds/useClassificationCmds）
      const combinationData = groupedItems.map(items => {
        return {
          ...items[0],
          // 配件名称
          accessoryCmds: items.map(el => {
            return {
              name: el.accessoryName,
              packingMaterialId: '',
            };
          }),
          // 用途分类
          useClassificationCmds: items.map(el => {
            return {
              classification: el.useClassification,
              packingMaterialId: '',
            };
          }),
          // 包材容量及价格
          capacityUnitPriceCmds: items.map(el => {
            if (!['OTHER', 'PRINT_COLOR_BOX'].includes(el.form)) {
              return {
                capacityUnit: el.capacityUnit,
                price: el.price,
                packingMaterialId: '',
              };
            } else {
              // 印刷类/其他
              return {
                capacityUnit: '',
                price: el.price,
                packingMaterialId: '',
              };
            }
          }),
        };
      });
      return combinationData;
    },
  },
};
</script>

<style lang="less" scoped>
.import-table {
  display: flex;
  align-items: center;
  margin-top: -20px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
.el-link {
  display: block;
  margin: 15px;
}
</style>
